import React from 'react'
import styles from './PackageGroup.module.css'

const PackageGroup = ({
    packGroup,
    onClick
}) => {
  const handleClick = () => {
    onClick(packGroup.id)
  }

  return (
    <div className={styles.subscriptionItem} onClick={handleClick}>
      {packGroup.name}
    </div>
  )
}

export default PackageGroup
